import EditProTable from './edit-pro-table';
export default EditProTable;
